import { UploadFile } from "@king-ict/eupisi-ui/models/UploadFile/UploadFile";

import { Attachment } from "../Shared/Attachment";
import { Request } from "./Request";

export enum MzomAppealTypeEnum {
  AppealAgainstEnrollmentPostponement = 1,
  AppealAgainstEnrollmentRequestingPostponement = 2,
  AppealAgainstEnrollmentDecision = 3,
  AppealAgainstAssignedInstitution = 4,
  AppealAgainstRejectedRequest = 5,
}

export enum MzomAppealStatusEnum {
  Accepted = 1,
  Rejected = 2,
}

export enum MzomAppealOutcomeEnum {
  EnrollmentApproved = 1,
  EnrollmentPostponed = 2,
  NewEnrollmentDecisionSpecialProgram = 3,
  EnrollInAnotherInstitution = 4,
  TemporaryExemptionApproved = 5,
}

export interface MzomAppeal {
  id: number;
  requestId: number;
  typeId?: MzomAppealTypeEnum;
  status?: MzomAppealStatusEnum;
  outcomeId?: MzomAppealOutcomeEnum;
  classification: string;
  associationNumber: string;
  note?: string;
  enrolledInstitutionId: number;
  enrolledInstitutionName?: string;
  attachments?: Attachment[];
  uploadFiles?: UploadFile[];

  request?: Request;
}

export type MzomAppealSavePayload = Partial<MzomAppeal> &
  Pick<MzomAppeal, "id" | "requestId">;
